import { render, staticRenderFns } from "./dialogDragSort.vue?vue&type=template&id=19aac7e7&scoped=true&"
import script from "./dialogDragSort.vue?vue&type=script&lang=js&"
export * from "./dialogDragSort.vue?vue&type=script&lang=js&"
import style0 from "./dialogDragSort.vue?vue&type=style&index=0&id=19aac7e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aac7e7",
  null
  
)

export default component.exports